export const TOTAL_ROUNDS = 21;
export const DRAW_ROUNDS = Array(TOTAL_ROUNDS + 1).fill(null).map((_, i) => i);
export const DRAW_ROUND_LINES = [1, 2, 3, 4];
export const PRINT_ALL_MATCHES = 'ALL';
